module.exports = __webpack_public_path__ + "fonts/fa-light-300.9d7a161.ttf";